
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/urology",
      function () {
        return require("private-next-pages/urology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/urology"])
      });
    }
  